import React, {useCallback} from 'react';
import ConditionGroup from './ConditionGroup/ConditionGroup';
import {useCategory} from '../../../data/hooks/categories';
import {useDispatch} from 'react-redux';
import {addSubCondition, addValue, changeOperator, changeValue, removeCondition, removeSubCondition, replaceField} from '../../../data/actions/query';
import {useFilterPreview} from '../../../data/hooks/preview';
import LayoutColumns from '../LayoutColumns/LayoutColumns';
import styles from './Condition.module.scss';
import InvalidFields from '../RequiredUserActions/InvalidFields/InvalidFields';

function Condition(props) {
    const {title, conditionIndex, condition, categories, showPreview} = props,
        category = useCategory(condition.category),
        previewCount = useFilterPreview(conditionIndex),
        dispatch = useDispatch();

    // Callbacks
    const handleRemoveCondition = useCallback(() => dispatch(removeCondition(conditionIndex)), [conditionIndex]),
        handleAddSubCondition = useCallback(subCondition => dispatch(addSubCondition(conditionIndex, subCondition)), [conditionIndex]),
        handleRemoveSubCondition = useCallback(subConditionIndex => dispatch(removeSubCondition(conditionIndex, subConditionIndex)), [conditionIndex]),
        handleOperatorChange = useCallback(
            (subConditionIndex, operator) => dispatch(changeOperator(conditionIndex, subConditionIndex, operator)),
            [conditionIndex]
        ),
        handleAddValue = useCallback((subConditionIndex, value = '') => dispatch(addValue(conditionIndex, subConditionIndex, value)), [conditionIndex]),
        handleChangeValue = useCallback(
            (subConditionIndex, valueIndex, value) => dispatch(changeValue(conditionIndex, subConditionIndex, valueIndex, value)),
            [conditionIndex]
        ),
        handleReplaceField = useCallback((subConditionIndex, field) => dispatch(replaceField(conditionIndex, subConditionIndex, field)), [conditionIndex]);

    return (
        <>
            {title ? (
                <LayoutColumns>
                    <h3>{title}</h3>
                </LayoutColumns>
            ) : null}
            <LayoutColumns>
                <div className={styles.title}>
                    {category.label}
                    <button type="button" className={styles.removeCondition} onClick={handleRemoveCondition}>
                        <span className="glyphicon glyphicon-remove-sign"></span>
                    </button>
                </div>
            </LayoutColumns>
            <LayoutColumns count={previewCount} filterPic>
                <ConditionGroup
                    className={styles.group}
                    condition={condition}
                    category={category}
                    onAddSubCondition={handleAddSubCondition}
                    onRemoveSubCondition={handleRemoveSubCondition}
                    onOperatorChange={handleOperatorChange}
                    onAddValue={handleAddValue}
                    onChangeValue={handleChangeValue}
                    onReplaceField={handleReplaceField}
                />
            </LayoutColumns>
        </>
    );
}

export default Condition;
